export const colors = [
    '#FFEB00', '#ff7c43', '#f95d6a', '#d45087', '#a05195', '#665191', '#2f4b7c', '#003f5c', '#546de5', '#f3a683',
    '#f7d794', '#778beb', '#e77f67', '#cf6a87', '#f19066', '#f5cd79', '#e15f41', '#c44569', '#786fa6', '#f8a5c2',
    '#63cdda', '#ea8685', '#596275', '#574b90', '#f78fb3', '#3dc1d3', '#e66767', '#303952', '#b6d7a8', '#d9ead3',
    '#9fc5e8', '#ffe599', '#f4cccc', '#f3f3f3', '#cfe2f3', '#f6b26b', '#93c47d', '#76a5af', '#8e7cc3', '#ffb6c1',
    '#87ceeb', '#ffdead', '#7fff00', '#6b8e23', '#ffd700', '#daa520', '#ff6347', '#4169e1', '#ff69b4', '#cd5c5c'
  ];

  